"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ProductIntroCard.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardLinkIcon = require("./CardLinkIcon");
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ProductIntroCard = _ref => {
  let {
    content = {},
    contentfulId
  } = _ref;
  const {
    logo,
    productName,
    header,
    isSubheaderLong,
    image,
    body,
    viewLessText,
    viewMoreText,
    cardLink,
    cardAlignment,
    imageSizes,
    Link
  } = content;
  const getWindowDimensions = () => {
    let width = 0;
    let height = 0;
    if (typeof window !== "undefined") {
      const {
        innerWidth,
        innerHeight
      } = window;
      width = innerWidth;
      height = innerHeight;
    }
    return {
      width,
      height
    };
  };
  const {
    width,
    height
  } = getWindowDimensions();
  const [showAccordion, setShowAccordion] = (0, _react.useState)(false);
  const [showSubheader, setShowSubheader] = (0, _react.useState)(true);
  const [dimensions, setDimensions] = (0, _react.useState)({
    height,
    width
  });
  const [cardAutoHeight, setCardAutoHeight] = (0, _react.useState)(false);
  const [isMobile, setIsMobile] = (0, _react.useState)(false);
  const [subheader, setSubHeader] = (0, _react.useState)("");
  const productNameMax = 60;
  const headerMax = 45;
  const subheaderMax = 140;
  const displayLinkButton = cardLink?.url || cardLink?.slug ? true : false;
  if (!header && !body) {
    return null;
  }
  const addEllipses = () => {
    if (productName?.length >= productNameMax || header?.length >= headerMax || content?.subheader?.length >= subheaderMax) {
      setSubHeader(content?.subheader?.substring(0, subheaderMax) + "...");
    }
    setSubHeader(content?.subheader);
  };
  const handleResize = () => {
    const {
      width,
      height
    } = getWindowDimensions();
    setDimensions({
      height,
      width
    });
    width < 376 ? setIsMobile(true) : setIsMobile(false);
  };
  (0, _react.useEffect)(() => {
    handleResize();
    addEllipses();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => {
        if (typeof window !== "undefined") {
          window.removeEventListener("resize", handleResize);
        }
      };
    }
  }, []);
  if (isMobile && showSubheader && !showAccordion) {
    setShowSubheader(false);
  }
  if (!isMobile && !showSubheader) {
    setShowSubheader(true);
  }
  const handleMoreClick = () => {
    if (isMobile && !showSubheader && !showAccordion) {
      setShowSubheader(true);
    }
    setShowAccordion(true);
    setTimeout(function () {
      setCardAutoHeight(true);
    }, 0);
  };
  const handleLessClick = e => {
    if (isMobile && showSubheader && showAccordion) {
      setShowSubheader(false);
    }
    setShowAccordion(false);
    setTimeout(function () {
      setCardAutoHeight(false);
    }, 1000);
  };
  const cardTarget = (0, _CTASectionMethods.checkForExternalLink)(cardLink?.url);
  const componentBody = body && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-product-intro-card__body-text`,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(body),
    "data-sb-field-path": "productDescriptionBody"
  });
  const componentFocusedImage = image?.focalPointImage && /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    focalPointImage: image?.focalPointImage,
    alt: image?.focalPointImage?.title,
    fullHeightWrapper: true,
    imageSizes: imageSizes
  });
  const componentImage = image && /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-product-intro-card__image`,
    alt: image?.altText ? image?.altText : "",
    src: image?.url,
    width: 100,
    "data-sb-field-path": "productImage"
  });
  const componentLogo = logo && /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-product-intro-card__logo`,
    alt: logo?.altText ? logo?.altText : "",
    src: logo?.url,
    "data-sb-field-path": "logo"
  });
  const componentSubheader = subheader && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-product-intro-card__subheader ${!showSubheader ? "hide" : ""}`,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(subheader),
    "data-sb-field-path": isSubheaderLong ? "subheaderLong" : "productDescriptionSubheader"
  });
  const componentJSX = /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__wrapper",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-product-intro-card__body`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__product-parent"
  }, componentLogo, productName && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__product",
    "data-sb-field-path": "productName"
  }, productName)), header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-product-intro-card__header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "productDescriptionHeader"
  }), componentSubheader, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-product-intro-card__accordion ${!showAccordion ? "hide" : ""}`
  }, image?.url && /*#__PURE__*/_react.default.createElement("figure", {
    className: "ter-product-intro-card__image"
  }, componentImage), image?.focalPointImage && /*#__PURE__*/_react.default.createElement("figure", {
    className: "ter-product-intro-card__image"
  }, componentFocusedImage), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__body-text"
  }, componentBody))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__link-holder"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__half-col ter-product-intro-card__half-col__left"
  }, showAccordion ? /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__link ter-product-intro-card__view-more-link",
    onClick: handleLessClick,
    "data-name": productName,
    "data-heading": header
  }, viewLessText, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__view-more-icon"
  }, "-")) : /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__link ter-product-intro-card__view-more-link",
    onClick: handleMoreClick,
    "data-name": productName,
    "data-heading": header
  }, viewMoreText, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__view-more-icon"
  }, "+"))), displayLinkButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-card__half-col ter-product-intro-card__half-col__right",
    "data-sb-field-path": "form"
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: cardLink?.contentfulId ? cardLink?.contentfulId : null,
    target: cardTarget === true ? "_blank" : "_self",
    className: "ter-product-intro-card__link",
    href: cardLink?.url,
    dataName: productName,
    dataHeading: header,
    Link: Link && Link
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-product-intro-card__link-text",
    "data-sb-field-path": cardLink?.isLinkLabel ? `${contentfulId}:linkLabel` : null
  }, cardLink?.text), /*#__PURE__*/_react.default.createElement(_CardLinkIcon.CardLinkIcon, {
    iconClass: "ter-product-intro-card__link-icon",
    external: cardTarget
  })))));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-product-intro-card 
      ${cardAlignment ? "ter-product-intro-card--reverse" : ""} 
      ${cardAutoHeight ? "ter-product-intro-card__auto-height" : ""}
      `
  }, componentJSX);
};
var _default = ProductIntroCard;
exports.default = _default;
ProductIntroCard.propTypes = {
  content: _propTypes.default.shape({
    logo: _propTypes.default.object,
    productName: _propTypes.default.string,
    header: _propTypes.default.string.isRequired,
    subheader: _propTypes.default.string,
    image: _propTypes.default.object,
    body: _propTypes.default.string,
    viewLessText: _propTypes.default.string,
    viewMoreText: _propTypes.default.string,
    cardLink: _propTypes.default.shape({
      url: _propTypes.default.string.isRequired,
      text: _propTypes.default.string.isRequired
    }),
    cardAlignment: _propTypes.default.bool
  })
};